module.exports = __webpack_public_path__ + "static/media/Plus2Activity.ca1bef7b.mp3";